export interface IHmsProfle{
  id: number;
  type:string;
  username:string;
  email:string;
  name:string;
  avatar:string;
  address:string;
}
